'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _Constants = require('ui-addon-avatars/Constants');

exports.default = (0, _immutable.Record)({
  avatar: _Constants.DEFAULT_CONTACT_AVATAR,
  email: null,
  firstName: '',
  lastName: '',
  phone: null,
  city: null,
  company: null,
  jobTitle: null,
  vid: null
}, 'Visitor');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/data/records/Visitor.js
// module id = 68
// module chunks = 0 1